<template>
<audio :key="src+volume+loop" ref="audio" :loop="loop" :src="src"></audio>
</template>

<script>
export default {
  props: {
    src: String,
    volume: Number,
    loop: Boolean,
    muted: Boolean,
    autoplay: Boolean
  },
  mounted() {
    if (this.$props.autoplay !== false) {
      this.play()
    }
  },
  updated() {
    if (this.$props.autoplay !== false) {
      this.play()
    }
  },
  methods: {
    play() {
      const { audio } = this.$refs
      const { volume, loop, src, muted } = this.$props
      if (src) {
        audio.src = src
        audio.volume = volume ? volume * 0.01 : 0.1
        audio.loop = !!loop
        audio.muted = muted
        audio.load()
        this.$nextTick(() => {
          audio.play()
        })
      } else {
        audio.pause()
      }
    }
  },
  watch: {
    muted() {
      const { audio } = this.$refs
      const { muted } = this.$props
      audio.muted = muted
    }
  }
}
</script>
